// menu-id.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuIdService {
  private imagePaths: { [id: number]: string } = {
    6130: '/assets/images/menuLogo/Afrisurelogo.svg',  
    6240: '/assets/images/menuLogo/nyalaLogo.png',  
    6050: 'assets/images/menuLogo/IAM.png',    
    3: 'assets/images/IAZ (Logo).png',    
    6210: '/assets/images/menuLogo/kenindia.png',  

  };
  private logoPathSubject = new BehaviorSubject<string | null>(null);
  logoPath$ = this.logoPathSubject.asObservable();
  private landingLogoPathSubject = new BehaviorSubject<string | null>(null);
  landingImagePath$ = this.landingLogoPathSubject.asObservable();
  private countryCodeSubject = new BehaviorSubject<string | null>(null);
  countryCode$ = this.countryCodeSubject.asObservable();
  
  // private colors: { [id: number]: string } = {
  //   1: '#2e3192',  // color for ID 1
  //   2: '#cfc04d',  // color for ID 2
  //   3: '#376092',  // color for ID 3
  //   // Add more color mappings for other IDs as needed
  // };

  // private tablebg: { [id: number]: { bgColor: string; textColor: string } } = {
  //   1: { bgColor: '#f2f2f2', textColor: '#000000' },  // For ID 1, white background and black text color
  //   2: { bgColor: '#000000', textColor: '#ffffff' },  // For ID 2, black background and white text color
  //   3: { bgColor: '#000000', textColor: '#ffffff' },  // For ID 2, black background and white text color

  //   // Add more color mappings for other IDs as needed
  // };

  // private mkIDSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // private akIIDSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // private IAZIDSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private activeImageURLSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  // private activeColorSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  // private activetableSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor() {
    // No HTTP request logic here

  }
  setLogoPath(path: string) {
    this.logoPathSubject.next(path);
  }
  setLandingImgPath(path: string) {
    this.landingLogoPathSubject.next(path);
  }
  setCountryCode(id: string) {
    this.countryCodeSubject.next(id);
  }
  getid(id: number) {   
    // const mkIDValue = id === 1;
    // this.mkIDSubject.next(mkIDValue);
    // const akIIDValue = id === 2;
    // this.akIIDSubject.next(akIIDValue);
    // const IAZIDValue = id === 3
    // this.IAZIDSubject.next(IAZIDValue);
    // if (!mkIDValue && !akIIDValue && !IAZIDValue) {
    //   this.mkIDSubject.next(true);

    // }

    // this.getImagePath(id); // Get image path for ID 1
    // this.getColorById(id); // Get color for ID 1
  }
  getImagePath(id: number): void {
    const imageURL = this.imagePaths[id];
    if (imageURL) {
      this.activeImageURLSubject.next(imageURL);
    } else {

    }
  }

  // Modify the getColorById method to accept the ID as a parameter
  // getColorById(id: number): void {
  //   const color = this.colors[id];
  //   if (color) {
  //     this.activeColorSubject.next(color);
  //   } else {
  //     this.activeColorSubject.next('#2e3192'); // Default color if the ID doesn't match
  //   }
  //   var table = this.tablebg[id];
  //   if (table) {
  //     this.activetableSubject.next(JSON.stringify(table));
  //   } else {
  //     this.activeColorSubject.next('');
  //   }
  // }

  // getMkID(): Observable<boolean> {
  //   return this.mkIDSubject.asObservable();
  // }

  // getAkID(): Observable<boolean> {
  //   return this.akIIDSubject.asObservable();
  // }

  // getIAZID(): Observable<boolean> {
  //   return this.IAZIDSubject.asObservable();
  // }

  getActiveImageURL(): Observable<string> {
    return this.activeImageURLSubject.asObservable();
  }

  // getActiveColor(): Observable<string> {
  //   return this.activeColorSubject.asObservable();
  // }

  // getTablecolor(): Observable<string> {
  //   return this.activetableSubject.asObservable();
  // }
  phoneCode() {
    let domain = window.location.hostname;
    if (domain == "sudlife-primez.insure.digital" || domain == "cholams-primez.insure.digital" || domain == "zuno-primez.insure.digital" || domain == "starhealth-primez.insure.digital") {
      return "IND"
    }
    else if (domain == "uaedemo-primez.insure.digital") {
      return "UAE";
    }
    else {
      return "KEN"
    }
  }
}
